var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const _fetch = (url, args, handlers, f) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield fetch(url, Object.assign(Object.assign({}, args), { 'headers': new Headers(Object.assign(Object.assign({}, args.headers), { 'Authorization': `Bearer ${window.localStorage.getItem('token')}` })) }));
        console.log(res.status);
        if (res.ok) {
            if (handlers && handlers.success) {
                const result = yield f(res);
                handlers.success(result);
                return result;
            }
            else {
                return f(res);
            }
        }
        else if (res.status == 401 || res.status == 403) {
            window.localStorage.clear();
            window.location.reload();
            return new Promise(() => { });
        }
        else if (handlers && handlers.error) {
            handlers.error(res);
            return null;
        }
        else {
            throw res.status;
        }
    }
    catch (e) {
        if (args.signal && args.signal.aborted) {
            return new Promise(() => { });
        }
        else {
            console.error(e);
            throw e;
        }
    }
});
const _fetchJson = (url, args, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetch(url, args, handlers, (x) => x.json()); });
const _fetchBlob = (url, args, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetch(url, args, handlers, (x) => x.blob()); });
const _fetchString = (url, args, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetch(url, args, handlers, (x) => x.text()); });
export const getBlob = (url, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetchBlob(url, { 'method': 'GET' }, handlers); });
export const getJson = (url, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetchJson(url, { 'method': 'GET' }, handlers); });
export const getJsonAbortable = (url, controller, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetchJson(url, { 'method': 'GET', 'signal': controller.signal }, handlers); });
export const getString = (url, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetchString(url, { 'method': 'GET' }, handlers); });
export const getStringAbortable = (url, controller, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetchString(url, { 'method': 'GET', 'signal': controller.signal }, handlers); });
export const postRawJson = (url, body, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetchJson(url, { 'method': 'POST', 'body': body }, handlers); });
export const postObjectJson = (url, body, handlers) => __awaiter(void 0, void 0, void 0, function* () { return postRawJson(url, JSON.stringify(body), handlers); });
export const postFormJson = (url, body, handlers) => __awaiter(void 0, void 0, void 0, function* () { return postRawJson(url, Object.keys(body).reduce((form, k) => { form.append(k, body[k]); return form; }, new FormData()), handlers); });
export const postRawBlob = (url, body, handlers) => __awaiter(void 0, void 0, void 0, function* () { return _fetchBlob(url, { 'method': 'POST', 'body': body }, handlers); });
export default {
    getJson,
    getString,
    postRawJson,
    postObjectJson,
    postFormJson,
    postRawBlob,
};
